<template>
  <div>
    <list
      row-key="StudentId"
      ref="list"
      unit="学生"
      :page="false"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.getLogListV2"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期">
          <el-select v-model="params.TermId" size="mini" @change="getSection">
            <template v-for="(i,index) in terms">
              <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            size="mini"
            :clearable="false"
            v-model="params.AttendanceDate"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="节次">
          <el-select v-model="params.SectionNumber" size="mini" clearable>
            <template v-for="(i,index) in sections">
              <el-option :key="index" :value="i.SectionId" :label="i.SectionName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" size="mini" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Normal" size="mini" clearable>
            <el-option :value="true" label="正常点名"></el-option>
            <el-option :value="false" label="未点名"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="日期" min-width="100px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WeekDay" label="星期" min-width="80px" />
        <el-table-column prop="SectionName" label="节次" />
        <el-table-column prop="ClassName" label="班级" min-width="100px" />
        <el-table-column prop="Teacher" label="任课教师" min-width="100px" />
        <el-table-column prop="RollCallTeacherName" label="最后点名教师" min-width="110px" />
        <!-- <el-table-column prop="NormalText" label="状态" min-width="60px" align="center" /> -->
        <el-table-column prop="Remark" label="备注" min-width="200px" show-overflow-tooltip />
        <el-table-column prop="RollCallTime" label="最后点名时间" min-width="160px" />
        <el-table-column prop="Subject" label="科目" min-width="100px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      term_api: require("@/api/ed/term").default,
      section_api: require("@/api/ed/section").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      params: {
        AttendanceDate: new Date(),
        SectionNumber: null,
        GradeId: null,
        ClassId: null,
        TermId: null,
        Normal: false,
      },
      terms: [], //学期列表
      sections: [], //课程节次列表
      grades: [], //年级列表
      classes: [], //班级列表
    };
  },
  mounted() {
    this.getTerm();
    this.getGrade();
  },
  methods: {
    onExport() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
    getTerm() {
      this.term_api.list().then((res) => {
        this.terms = res.Data;
        if (this.terms.length > 0) {
          this.params.TermId = this.terms[0].TermId;
          this.$refs.list.initQueryParams.TermId = this.params.TermId;
          this.getSection();
        }
      });
    },
    getSection() {
      // this.section_api.list({ TermId: this.params.TermId }).then((res) => {
      //   this.sections = res.Data;
      // });
      this.sections = [];
      for (let i = 1; i <= 10; i++) {
        this.sections.push({
          SectionId: i,
          SectionName: "第" + i + "节课",
        });
      }
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.params.ClassId = null;
        this.classes = res.Data;
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>